// extracted by mini-css-extract-plugin
export var arrows = "_2p-5";
export var decrementer = "_2p-9";
export var disabled = "_2p-3";
export var error = "_2p-1";
export var hiddenText = "_2p-a";
export var incrementer = "_2p-8";
export var input = "_2p-7";
export var inputWrapper = "_2p-0";
export var leadingIcon = "_2p-b";
export var readonly = "_2p-2";
export var regular = "_2p-6";
export var small = "_2p-4";